/**
 * File type detection and validation utilities for upload functionality.
 */

import { FILE_CONFIG } from '../../config/constants';

// Re-export constants for convenience (imported from central config)
export const SUPPORTED_VIDEO_TYPES = FILE_CONFIG.ALLOWED_VIDEO_TYPES;
export const SUPPORTED_IMAGE_TYPES = FILE_CONFIG.ALLOWED_IMAGE_TYPES;

/**
 * Determines if a file is a video based on MIME type
 * @param {File} file - The file to check
 * @returns {boolean} True if file is a supported video type
 */
export const isVideoFile = (file) => {
  return SUPPORTED_VIDEO_TYPES.includes(file.type.toLowerCase());
};

/**
 * Determines if a file is an image based on MIME type
 * @param {File} file - The file to check
 * @returns {boolean} True if file is a supported image type
 */
export const isImageFile = (file) => {
  return SUPPORTED_IMAGE_TYPES.includes(file.type.toLowerCase());
};

/**
 * Validates a file is either an image or video
 * @param {File} file - The file to validate
 * @returns {Object} { valid: boolean, type: 'image'|'video'|null, error: string|null }
 */
export const validateFileType = (file) => {
  if (isImageFile(file)) {
    return { valid: true, type: 'image', error: null };
  }
  if (isVideoFile(file)) {
    return { valid: true, type: 'video', error: null };
  }
  return {
    valid: false,
    type: null,
    error: `Unsupported file type: ${file.type}. Supported formats: JPG, PNG, HEIC, MP4, MOV, WebM`
  };
};

/**
 * Gets file extension from filename
 * @param {string} filename - The filename
 * @returns {string} The file extension (lowercase, without dot)
 */
export const getFileExtension = (filename) => {
  return filename.split('.').pop().toLowerCase();
};
